<script lang="ts">
    import { _ } from "svelte-i18n"
    import { onMount } from "svelte"
    import StarRating from "../../widgets/StarRating.svelte"
    import { postPurchaseFeedback } from "../../../api"

    let feedbackToken: string | null = $state(null)
    let rating = $state(0)
    let comment = $state("")
    let submitted = $state(false)
    let submitting = $state(false)
    let error = $state("")

    onMount(() => {
        feedbackToken = window.sessionStorage.getItem("feedbackToken")
    })

    async function submit() {
        if (!feedbackToken || rating === 0) return

        submitting = true
        error = ""
        try {
            await postPurchaseFeedback({ rating, comment: comment || undefined }, feedbackToken)
            submitted = true
            window.sessionStorage.removeItem("feedbackToken")
        } catch (e: any) {
            if (e?.data?.error?.includes("already submitted")) {
                submitted = true
                window.sessionStorage.removeItem("feedbackToken")
            } else {
                error = $_("feedback.error")
            }
        } finally {
            submitting = false
        }
    }
</script>

{#if feedbackToken}
    <section class="purchase-feedback">
        {#if submitted}
            <div class="feedback-thanks">
                <h3>{$_("feedback.thank-you-title")}</h3>
                <p>{$_("feedback.thank-you-text")}</p>
            </div>
        {:else}
            <h3>{$_("feedback.title")}</h3>
            <p>{$_("feedback.description")}</p>

            <div class="rating-row">
                <StarRating {rating} onchange={(v) => (rating = v)} />
            </div>

            <textarea bind:value={comment} placeholder={$_("feedback.comment-placeholder")} maxlength="2000" rows="5"
            ></textarea>

            {#if error}
                <div class="error-message" role="alert">{error}</div>
            {/if}

            <button type="button" class="button primary" onclick={submit} disabled={rating === 0 || submitting}>
                {#if submitting}
                    {$_("feedback.submitting")}
                {:else}
                    {$_("feedback.submit")}
                {/if}
            </button>
        {/if}
    </section>
{/if}

<style lang="less">
    @import "../../../css/variables.less";

    .purchase-feedback {
        margin-top: 2rem;
        padding: 1.5rem;
        background: var(--comp--card--background, #f9f9f9);
        border-radius: 8px;
        border: 1px solid var(--comp--card--border, #e0e0e0);

        h3 {
            margin: 0 0 0.5rem 0;
            font-size: 1.2rem;
        }

        p {
            margin: 0 0 1rem 0;
            color: var(--comp--text--secondary, #666);
            font-size: 0.95rem;
        }

        .rating-row {
            margin-bottom: 1rem;
        }

        textarea {
            width: 100%;
            padding: 0.75rem;
            border: 1px solid var(--comp--input--border, #ccc);
            border-radius: 4px;
            font-family: inherit;
            font-size: 0.95rem;
            resize: vertical;
            min-height: 80px;
            margin-bottom: 1.5rem;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-color: var(--primary, #f5a623);
            }
        }

        .error-message {
            background-color: var(--color-error-background, #ffebee);
            color: var(--color-error-text, #c62828);
            padding: 0.6rem 1rem;
            border-radius: 4px;
            font-size: 0.9rem;
            margin-bottom: 1rem;
        }

        .button.primary {
            width: 100%;
            margin-top: 1rem;
        }

        .feedback-thanks {
            text-align: center;
            padding: 1rem 0;

            h3 {
                color: var(--primary, #2e7d32);
            }
        }
    }
</style>
